

const redRes=(state={},action)=>{
    switch(action.type)
    {
        case 'response':
            if(action.payload != undefined){
                return action.payload;
            }
            else{
                return null
            }
            

        default:
            return state
    }
}
export default redRes